<template>
    <el-dialog :title="$t('BusinessPurchaseApplyDetail.dialogText2')" :visible.sync="logVisible" width="500px">
        <el-table :data="logList" border script max-height="600px">
          <el-table-column prop="lastUpdateDate" :label="$t('BjDialogListConfig.Operationtime')" align="center">
            <template slot-scope="scope">
                <template v-if="false" />
                <span v-else>{{ scope.row.lastUpdateDate | timeFilters(scope.row.lastUpdateDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="operator" :label="$t('BjDialogListConfig.Operator')" align="center" />
          <el-table-column prop="content" :label="$t('BjDialogListConfig.Remarks')" align="center" />
        </el-table>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
            <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            logList: [],
            logVisible: false
        }
    },
    methods:{
        handleClose() {
            this.logVisible = false;
        },
        confirm(){
            this.logVisible = false;
        }
    }
}
</script>